export const GET_CONFIG_START = "GET_CONFIG_START";
export const GET_CONFIG_SUCCESS = "GET_CONFIG_SUCCESS";
export const GET_CONFIG_ERROR = "GET_CONFIG_ERROR";
export const SET = "config/SET";
